<template>
	<div>
		<div style="display: flex;flex-direction: column;width: 100%;height: 100%;">
			<div class="box" style="display: flex;width: 100%;height: 100%;">
				<div v-loading="loadingTree" style="width: 16%;height: 100%;overflow-y: scroll;">
					<el-tree ref="tree" :current-node-key="currentId" 
						default-expand-all node-key="id" class="tree" :data="list" :props="defaultProps"
						@node-click="handleNodeClick">
						<span @click="currentData = data;currentNode = node" class="custom-tree-node"
							slot-scope="{ node, data }">
							<span>{{ node.label }}</span>
							<span>
								<!-- 	<i @click.stop.prevent="downLoadFile" style="margin-right: 10px;"
									class="el-icon-download tit-icon"></i> -->
								<i @click.stop.prevent="addFile(data,node)" style="margin-right: 10px;"
									class="el-icon-circle-plus-outline tit-icon"></i>
								<i @click.stop.prevent="delFile(data,node)" v-if="data.pid != 0"
									style="margin-right: 10px;" class="el-icon-delete tit-icon"></i>
							</span>
						</span>
					</el-tree>
				</div>
				<div v-loading="loading"
					style="flex-direction: column;align-items: center;width: 100%;background-color: #fff;height: 100%;"
					class="layout-flex-center">
					<div
						style="height: 60px;width: 100%;background-color: #ffffff;display: flex;align-items: center;justify-content: space-between;">
						<div style="display: flex;align-items: center;">
							<el-button style="align-self: flex-end;margin: 20px;" type="primary" @click="confirmImg"><i
									class="el-icon-check"></i> 选择</el-button>
							<div @click="copyLink" style="margin-left: 30px;cursor: pointer;font-size: 16px;"><i
									style="color: #55aaff;margin-right: 6px;" class="el-icon-document-copy"></i> 复制链接
							</div>
							<div @click="delImg" style="margin-left: 30px;cursor: pointer;font-size: 16px;"><i
									style="color: #55aaff;margin-right: 6px;" class="el-icon-delete"></i> 删除</div>
							<div @click="reName" style="margin-left: 30px;cursor: pointer;font-size: 16px;"><i
									style="color: #55aaff;margin-right: 6px;" class="el-icon-edit"></i> 重命名</div>
						</div>
						<div style="display: flex;align-items: center;margin-right: 20px;">
							<el-popover placement="bottom" width="400" trigger="click">

								<el-input placeholder="请输入搜索图片名称" v-model="imgSearch" clearable>
									<el-button @click="searchImg" slot="append" icon="el-icon-search"></el-button>
								</el-input>
								<el-button slot="reference" type="primary" plain><i class="el-icon-search"
										style="font-size: 18px;"></i></el-button>
							</el-popover>
							<!-- <el-popover style="margin-left: 20px;" placement="bottom" width="400" trigger="click">
								<div>
									<div>
										<div>类型</div>
										<div style="display: flex;align-items: center;">
											<el-button>创建时间</el-button>
											<el-button>文件名称</el-button>
										</div>
									</div>
									<div>
										<div>排序</div>
										<div style="display: flex;align-items: center;">
											<el-button>倒序</el-button>
											<el-button>顺序</el-button>
										</div>
									</div>
								</div>
								<el-button slot="reference" type="primary" plain><i class="el-icon-s-operation"
										style="font-size: 18px;"></i></el-button>
							</el-popover> -->
							<el-button style="margin-left: 20px;" @click="checkUpFile()" type="primary" plain><i
									class="el-icon-upload2" style="font-size: 18px;"></i><span
									style="font-size: 16px;">上传文件</span></el-button>
						</div>
					</div>
					<div
						style="overflow-y: scroll;display: flex;flex-wrap: wrap;width: 100%;overflow-y: scroll;height: calc(100% - 120px);background-color: #f7f9fc;">
						<div @dblclick="dbSelectImg(item)" @click="selectImg(item)"
							class="layout-flex-justify-content-center img-item"
							style="width: 140px;margin: 10px;flex-direction: column;align-items: center;height: 172px;"
							:style="{'border':item.path == selectItem.path?'solid 2px #55aaff':'solid 1px #eaeaea'}"
							v-for="(item,index) in imgList" :key="index">
							<img v-if="getFileType(item.name) == 'image'" style="width: 137px;height: 137px;object-fit: cover;" :src="item.url" />
							<video muted v-if="getFileType(item.name) != 'image'" style="width: 137px;height: 137px;object-fit: cover;margin-left: 1px;" >
								<source :src="item.url" type="video/webm">
							</video>
							<div
								style="height: 31px;display: flex;align-items: center;border-top: solid 1px #eaeaea;width: 100%;">
								<div
									style="width: 120px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;padding: 5px;">
									{{item.name}}
								</div>
							</div>
						</div>
					</div>
					<div
						style="height: 60px;width: 100%;background-color: #ffffff;display: flex;align-items: center;justify-content: center;">
						<el-pagination :page-size="20" v-if="list.length > 0" layout="prev, pager, next" :total="image_total"
							@current-change="sizeChange">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>

		<el-dialog width="30%" style="margin-top: 30px;" :modal="false" custom-class="dialogl-box" title="新建文件夹"
			:visible.sync="dialogVisibleFile" :before-close="()=>{dialogVisibleFile = false}">
			<el-input style="width: 80%;margin-left: 10%;margin-top: 20px;" v-model="inputFile"
				placeholder="请输入内容"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button style="margin-top: 20px;" @click="dialogVisibleFile = false">取 消</el-button>
				<el-button style="margin-top: 20px;" type="primary" @click="confirmAddFile">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog width="30%" style="margin-top: 30px;" :modal="false" custom-class="dialogl-box" title="重命名"
			:visible.sync="dialogVisibleReName" :before-close="()=>{dialogVisibleReName = false}">
			<el-input style="width: 80%;margin-left: 10%;margin-top: 20px;" v-model="inputReName"
				placeholder="请输入内容"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button style="margin-top: 20px;" @click="dialogVisibleReName = false">取 消</el-button>
				<el-button style="margin-top: 20px;" type="primary" @click="confirmReName()">确 定</el-button>
			</span>
		</el-dialog>


		<el-dialog width="30%" style="margin-top: 30px;" :modal="false" custom-class="dialogl-box" title="上传文件"
			:visible.sync="upFile" :before-close="closeUpImg">

			<el-upload :show-file-list="false" :file-list="fileList" :http-request="upFileConfirm" class="upload-demo"
				drag action="https://jsonplaceholder.typicode.com/posts/" multiple>
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">点击上传，或<em>将文件拖到此处</em></div>
			</el-upload>
			<div
				style="display: flex;flex-direction: column;justify-content: center;align-items: center;margin-top: 20px;">
				<div style="width: 450px;margin-top: 10px;" v-for="(item,index) in fileList" :key="index">
					<div style="display: flex;justify-content: space-between;">
						<div>{{item.name}}</div>
						<div>{{item.state == 'success'?'完成':'失败'}}</div>
					</div>
					<div style="margin-top: 10px;">
						<el-progress :percentage="item.percentage"
							:color="item.state == 'success'?'#67c23a':'#ff0000'"></el-progress>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getDirectories,
		getFiless,
	} from '../../api/img.js'
	import {
		getSearchDesignFileManagersFiles,
		getDesignFileManagerDirectories,
		getDesignDelFileManagerDirectories,
		getDesignAddFileManagerDirectories,
		getDesignFileManagerupload,
		getDesignFileManagersFiles,
		getDesignFileManagersRename
	} from '../../api/all.js'
	export default {
		props: {},
		data() {
			return {
				currentPage: 1,
				currentId: "",
				imgSearch: "",
				dialogVisibleReName: false,
				inputReName: "",
				time: {},
				fileList: [],
				upFile: false,
				currentData: null,
				currentNode: null,

				inputFile: "",
				dialogVisibleFile: false,
				selectItem: {

				},
				base_folder: "",
				loadingTree: false,
				image_total: 1,
				loading: false,
				imgList: [],
				list: [],
				defaultProps: {
					children: 'children',
					label: 'name'
				}
			}
		},

		async mounted() {
			this.init()

		},
		methods: {
			
			getFileType(filename) {
			  // 获取文件扩展名（转换为小写以便比较）
			  const ext = filename.split('.').pop().toLowerCase();
			  
			  // 图片类型扩展名
			  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff'];
			  
			  // 视频类型扩展名
			  const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv', 'webm', 'mpeg'];
			  
			  if (imageExtensions.includes(ext)) {
			    return 'image';
			  } else if (videoExtensions.includes(ext)) {
			    return 'video';
			  } else {
			    return 'unknown';
			  }
			},
			
			async searchImg() {
				try {
					this.loading = true
					let base_folder;
					console.log('currentData', this.currentData)
					// if()
					// let wsid = this.$cookies.get("wsid")
					// let data = await getSearchDesignFileManagersFiles({
					// 	wsid
					// })
					this.sizeChange(this.currentPage)
				} catch (e) {
					this.loading = false
					this.$message.error(e.response.data.message)
				}
			},
			closeUpImg() {
				this.upFile = false
				if (this.fileList.length > 0) {
					this.fileList = []
					this.handleNodeClick(this.currentData, this.currentNode)
				}
			},
			copyLink() {
				console.log(this.selectItem)
				if (!this.selectItem.path) {
					this.$message.error('请选择文件')
					return
				}

				navigator.clipboard.writeText(this.selectItem.url)
				this.$message.success('复制完成')
			},
			async confirmReName() {
				try {
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					let fileExtension = this.selectItem.name.substring(this.selectItem.name.lastIndexOf('.') + 1);
					await getDesignFileManagersRename({
						new_name: this.inputReName + '.' + fileExtension,
						origin_name: this.selectItem.path,
						wsid
					})
					this.loading = false
					this.dialogVisibleReName = false
					this.handleNodeClick(this.currentData, this.currentNode)
				} catch (e) {
					console.log('e', e)
					this.loading = false

					this.$message.error(e.response.data.message)
				}
			},
			async reName() {
				if (!this.selectItem.path) {
					this.$message.error('请选择文件')
					return
				}
				this.dialogVisibleReName = true


			},
			async delImg() {
				if (!this.selectItem.path) {
					this.$message.error('请选择文件')
					return
				}
				try {
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					await getDesignFileManagersFiles({
						files: [this.selectItem.name],
						path: this.currentData.path,
						wsid
					})
					this.handleNodeClick(this.currentData, this.currentNode)
					this.loading = false
				} catch (e) {
					this.loading = false
					this.$message.error('删除失败')
					this.$message.error(e.message)
				}


			},
			getPercentage(e) {
				let that = this
				that.time[e.id] = setInterval(() => {
					e.percentage = e.percentage + 10
					console.log('e.percentage', e.percentage)
					that.$forceUpdate()
					if (e.percentage == 100) {
						clearInterval(that.time[e.id])
					}
				}, 20)
			},
			checkUpFile() {
				if (!this.currentNode && !this.currentData) {
					this.$message.error('请选择文件夹')
					return
				}
				this.upFile = true
			},
			// 将参数转换成功 formdata 接收格式
			stringify(data) {
				const formData = new FormData()
				for (const key in data) {
					// eslint-disable-next-line no-prototype-builtins
					if (data.hasOwnProperty(key)) {
						if (data[key]) {
							if (data[key].constructor === Array) {
								if (data[key][0]) {
									if (data[key][0].constructor === Object) {
										formData.append(key, JSON.stringify(data[key]))
									} else {
										data[key].forEach((item, index) => {
											formData.append(key + `[${index}]`, item)
										})
									}
								} else {
									formData.append(key + '[]', '')
								}
							} else if (data[key].constructor === Object) {
								formData.append(key, JSON.stringify(data[key]))
							} else {
								formData.append(key, data[key])
							}
						} else {
							if (data[key] === 0) {
								formData.append(key, 0)
							} else {
								formData.append(key, '')
							}
						}
					}
				}
				return formData
			},
			async upFileConfirm(e) {
				console.log('this.currentData', this.currentData)
				console.log('e', e.file)
				// let formData = new FormData();
				// formData.append('path', this.currentData.path);
				// formData.append('file', e.file);
				// console.log('formData', formData)
				// console.log(formData.get('file'))
				let formData = this.stringify({
					file: e.file,
					path: this.currentData.path
				})
				console.log('formData', formData)

				try {
					let wsid = this.$cookies.get("wsid")
					// 创建FormData对象
					await getDesignFileManagerupload({
						formData,
						wsid
					})
					let item = {
						name: e.file.name,
						state: "success",
						percentage: 0,
						id: new Date().getTime()
					}
					this.fileList.push(item)
					this.$nextTick(() => {
						this.getPercentage(item)

					})
					console.log('fileList', this.fileList)
				} catch (e) {
					this.fileList.push({
						name: e.name,
						state: "error"
					})
					console.log('e', e)
					console.log('this.currentData', this.currentData)
					this.$message.error(e.message)
				}

			},
			async init() {
				try {
					this.loadingTree = true
					let wsid = this.$cookies.get("wsid")
					let data = await getDirectories({
						wsid
					})
					this.list = data.data

					console.log('this.list', this.list)
					if (this.list.length > 0) {
						this.currentData = this.list[0]
						this.currentNode = this.list[0]
						this.base_folder = this.list[0].path
						this.currentId = this.list[0].id 

						this.$nextTick(() => {
							this.$refs.tree.setCurrentKey(this.list[0].id)
						});
					}


					// let wsid = this.$cookies.get("wsid")
					let imgData = await getFiless({
						base_folder: this.base_folder,
						page: 1,
						per_page: 20,
						wsid,
						sort: "created",
						keyword: "",
						order: "desc"

					})
					this.imgList = imgData.data.images
					this.image_total = imgData.data.image_total

					this.loadingTree = false
				} catch (e) {
					this.loadingTree = false
					this.$message.error('请求失败')
					this.$message.error(e.message)
				}
			},
			async confirmAddFile() {
				console.log(this.currentData)
				console.log(this.currentNode)
				try {

					// https://shop910.com/admin/1/file_manager/files?base_folder=1&page=2&per_page=20&sort=created&keyword=&order=desc
					this.loadingTree = true
					let wsid = this.$cookies.get("wsid")
					await getDesignAddFileManagerDirectories({
						name: this.currentData.path + '/' + this.inputFile,
						wsid
					})
					this.loadingTree = false
					this.inputFile = ""
					this.dialogVisibleFile = false
					this.init()
				} catch (e) {
					this.$message.error("添加失败")
					this.$message.error(e.message)
					console.log('e', e)
					this.dialogVisibleFile = false
					this.loadingTree = false
				}
			},
			handleClose() {
				this.dialogVisibleFile = false
				this.inputFile = ''
			},
			async delFile(e, node) {
				console.log('e', e)
				console.log('node', node)
				try {
					this.loadingTree = true
					let wsid = this.$cookies.get("wsid")
					await getDesignDelFileManagerDirectories({
						name: e.path,
						wsid
					})
					this.remove(node, e)
					this.loadingTree = false
				} catch (e) {
					console.log('e', e)
					this.loadingTree = false
				}
			},
			remove(node, data) {
				const parent = node.parent;
				const children = parent.data.children || parent.data;
				const index = children.findIndex(d => d.id === data.id);
				children.splice(index, 1);
			},
			async downLoadFile() {
				try {

				} catch {

				}
			},
			async addFile(data, node) {
				try {
					this.currentData = data
					this.currentNode = node
					this.dialogVisibleFile = true
				} catch (e) {

				}
			},
			dbSelectImg(e) {
				this.selectItem = e
				this.confirmImg()
			},
			selectImg(e) {
				this.selectItem = e
				console.log('this.selectItem', this.selectItem)
			},
			confirmImg() {
				if (this.selectItem.path) {
					this.$emit("confirmImg", this.selectItem)
				} else {
					this.$message.error("请选择文件")
				}
				console.log('1')
			},
			async sizeChange(e) {
				console.log('e', e)
				console.log('this.path', this.path)
				this.currentPage = e
				this.loading = true
				let wsid = this.$cookies.get("wsid")
				let data = await getFiless({
					base_folder: this.base_folder,
					page: e,
					per_page: 20,
					wsid,
					sort: "created",
					keyword: this.imgSearch,
					order: "desc"
				})
				console.log('data', data)
				this.imgList = data.data.images
				this.image_total = data.data.image_total
				this.loading = false
				console.log('imgList', this.imgList)
				this.loading = false
			},
			async handleNodeClick(e, n) {
				try {
					this.loading = true
					console.log('e', e)
					this.currentData = e
					this.currentNode = n
					this.base_folder = e.path

					let wsid = this.$cookies.get("wsid")
					let data = await getFiless({
						base_folder: e.path,
						page: 1,
						per_page: 20,
						wsid,
						sort: "created",
						keyword: '',
						order: "desc"
					})
					console.log('data', data)
					this.imgList = data.data.images
					this.image_total = data.data.image_total
					this.loading = false
					console.log('imgList', this.imgList)
				} catch (e) {
					this.loading = false
					this.$message.error("请求失败")
					this.$message.error(e.message)
				}

			}
		}
	}
</script>

<style scoped lang="scss">
	// ::v-deep .el-dialog__body{
	// 	display: flex;
	// 	justify-content: center;
	// 	flex-direction: column;
	// 	align-items: center;
	// }
	::v-deep .upload-demo {
		margin: auto;
		padding: 0px;
		width: 450px;
		display: flex;
		justify-content: center;
		flex-direction: column;

		.el-upload {
			padding: 0px;
			width: 450px;

			.el-upload-dragger {
				.el-icon-upload {
					font-size: 40px;
				}

				padding: 0px;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				width: 450px;
			}
		}
	}

	::v-deep .dialogl-box {
		.el-dialog__header {
			.el-dialog__title {
				color: #000000;
			}
		}

	}


	.tit-icon:hover {
		color: #55aaff;
	}

	.selectd {
		border: solid 2px #55aaff;
	}

	.img-item {
		cursor: pointer;
		border: solid 2px #6f6f6f;
	}

	.img-item:hover {
		border: solid 2px #55aaff;
	}

	.box {
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;

	}

	::-webkit-scrollbar {
		display: none;
	}

	scrollbar-hidden {
		scrollbar-width: none;
	}

	scrollbar-hidden {
		-ms-overflow-style: none;
	}

	scrollbar-hidden::-webkit-scrollbar {
		display: none;
	}



	// ::v-deep .el-tree-node__content {
	// 	padding: 4px 0px;
	// 	background-color: #293042 ;
	// 	&:hover {
	// 		//    background-color: #293042;
	// 		// opacity: 0.4;
	// 		// color:#fff;

	// 		background-color: rgba(255, 255, 255, 0.15);
	// 		backdrop-filter: blur(0px);
	// 		-webkit-backdrop-filter: blur(0px);
	// 		-webkit-box-shadow: rgba(142, 142, 142, 0.19) 0px 6px 15px 0px;
	// 		-webkit-border-radius: 0px;
	// 		color: rgba(255, 255, 255, 1);
	// 	}
	// }

	::v-deep .el-tree {
		background-color: #293042;
		color: #fff;

		.el-tree-node {

			background-color: #293042;
			// .el-tree-node__content {

			// 	// background-color: #293042;
			// }
			.el-tree-node__content {
				padding: 5px 0px;
				background-color: #293042;

				&:hover {
					//    background-color: #293042;
					// opacity: 0.4;
					// color:#fff;

					background-color: rgba(255, 255, 255, 0.15);
					backdrop-filter: blur(0px);
					-webkit-backdrop-filter: blur(0px);
					-webkit-box-shadow: rgba(142, 142, 142, 0.19) 0px 6px 15px 0px;
					-webkit-border-radius: 0px;
					color: rgba(255, 255, 255, 1);
				}
			}
		}

		.is-current>.el-tree-node__content {
			// background-color: rgba(41, 48, 66, 1);
			// backdrop-filter: blur(0px);
			// -webkit-backdrop-filter: blur(0px);
			// -webkit-border-radius: 0px;
			// color: rgba(255, 255, 255, 1);

			background-color: rgba(255, 255, 255, 0.15);
			backdrop-filter: blur(0px);
			-webkit-backdrop-filter: blur(0px);
			-webkit-box-shadow: rgba(142, 142, 142, 0.19) 0px 6px 15px 0px;
			-webkit-border-radius: 0px;
			color: rgba(255, 255, 255, 1);

			border-left: solid 3px #55aaff;
		}

	}

	.custom-tree-node {
		display: flex;
		justify-content: space-between;
		width: 100%;
		align-items: center;
		font-size: 14px;
	}
</style>